import { Modal } from 'bootstrap';

type ModalRule = {
    errorSelector: string;
    modalSelector?: string;
    triggerTarget?: string;
};

const MODAL_RULES: ModalRule[] = [
    { errorSelector: '.note-modal-errors', triggerTarget: '#add-note' },
    { errorSelector: '.email-modal-errors', triggerTarget: '#send-email' },
    { errorSelector: '.ep-modal-errors', triggerTarget: '#end-filing-period' },
    { errorSelector: '.terminate-modal-errors', triggerTarget: '#terminate-registration' },
    { errorSelector: '.email-success', modalSelector: '.email-success' },
    { errorSelector: '.edit-lr-error', modalSelector: '.edit-lr-error' },
    { errorSelector: 'aside#welcome', modalSelector: 'aside#welcome' },
    { errorSelector: '.account-preform-errors', modalSelector: '.account-preform-errors' },
    { errorSelector: '.user-created-success', modalSelector: '.user-created-success' },
    { errorSelector: '.organization-created-success', modalSelector: '.organization-created-success' },
    { errorSelector: '.resend-confirm-email-success', modalSelector: '.resend-confirm-email-success' },
    { errorSelector: '.create-statement-success', modalSelector: '.create-statement-success' },
    { errorSelector: '.create-note-success', modalSelector: '.create-note-success' },
    { errorSelector: '.create-statement-errors', modalSelector: '.create-statement-errors' },
    { errorSelector: '.completed-activity-report', modalSelector: '.completed-activity-report' },
    { errorSelector: '.submitted-personal-disclosure', modalSelector: '.submitted-personal-disclosure' },
    { errorSelector: '.completed-activity-report-amendment', modalSelector: '.completed-activity-report-amendment' },
    { errorSelector: '.submitted-registration', modalSelector: '.submitted-registration' },
];

const triggerModalByTarget = (target: string) => {
    const trigger = document.querySelector<HTMLElement>(
        `[data-bs-target="${target}"], [data-target="${target}"]`
    );

    trigger?.click();
};

const showModal = (selector: string) => {
    const element = document.querySelector<HTMLElement>(selector);
    if (!element) return;

    Modal.getOrCreateInstance(element).show();
};

const applyModalRules = () => {
    if ($('.eos-modal-errors').length) {
        $('span.eos-tooltip').trigger('click');
    }

    MODAL_RULES.forEach((rule) => {
        if (!$(rule.errorSelector).length) return;

        if (rule.triggerTarget) {
            triggerModalByTarget(rule.triggerTarget);
            return;
        }

        if (rule.modalSelector) {
            showModal(rule.modalSelector);
        }
    });
};

$(document).on('turbo:load turbo:render', applyModalRules);